export interface CalendarModel {
  today: TodayModel;
  years: CalendarYearModel[];
}

export interface TodayModel {
  day: number;
  month: number;
  year: number;
}

export interface CalendarYearModel {
  year: number;
  months: CalendarMonthModel[];
}

export interface CalendarMonthModel {
  month: number;
  firstWeekDay: number;
  weeks: CalendarWeekModel[];
}

export interface CalendarWeekModel {
  week: number;
  days: CalendarDayModel[];
}

export interface CalendarDayModel {
  day: number;
  marks: any[];
  special?: any[];
  notActive?: boolean;
}

export enum MONTH {
  'Janeiro' = 0,
  'Fevereiro' = 1,
  'Março' = 2,
  'Abril' = 3,
  'Maio' = 4,
  'Junho' = 5,
  'Julho' = 6,
  'Agosto' = 7,
  'Setembro' = 8,
  'Outubro' = 9,
  'Novembro' = 10,
  'Dezembro' = 11
}

export enum MONTHSHORT {
  'jan' = 0,
  'fev' = 1,
  'mar' = 2,
  'abr' = 3,
  'mai' = 4,
  'jun' = 5,
  'jul' = 6,
  'ago' = 7,
  'set' = 8,
  'out' = 9,
  'nov' = 10,
  'dez' = 11
}

export enum CALENDARVIEW {
  Month = 'Mês',
  Week = 'Semana',
  Day = 'Dia',
  Results = 'Resultados'
}

export interface MenuAction {
  select: boolean;
  text: string;
}

export interface RequestAction {
  index: number;
  list: MenuAction []
}